var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-dialog-component',{attrs:{"showInfoIcon":false,"showClose":true,"open":_vm.open,"title":_vm.$t(_vm.title),"body":_vm.$t(_vm.body),"height":"400px","width":"33vw","maxWidth":"600px","right":"50px","bottom":"50px","overlay":false,"center":false},on:{"closeDialog":_vm.closeDialog}})
}
var staticRenderFns = []

export { render, staticRenderFns }